"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductPropertySelector = ProductPropertySelector;
const React = __importStar(require("react"));
const property_1 = require("@genesys/property");
const AuthorizationTools = __importStar(require("@genesys/shared/lib/authorization"));
const PropertiesSelectorElements = __importStar(require("./elements"));
const readonly_property_selector_1 = require("./readonly-property-selector");
const UserProfile = __importStar(require("../user-profile"));
function ProductPropertySelector({ conversionParameters, fieldGroup, fieldName, filterPrettyPrint, isQuantitySelectorActive, onPropertyFormatChanged, onPropertyFormatCleared, onPropertyFormatSelectorToggled, onQuantityChange, valueSources, selectorInfo, translatePropertyValue }) {
    const { propertyName, selectorComponentProps: { selectedProperties, includeCodes, validationFilter, quantity, valueItems } } = selectorInfo;
    if (isReadonly(valueSources, selectedProperties, propertyName)) {
        return (React.createElement(readonly_property_selector_1.ReadonlyPropertySelector, { fieldName: fieldName, conversionParameters: conversionParameters, fieldGroup: fieldGroup, filterPrettyPrint: filterPrettyPrint, includeCodes: includeCodes, isQuantitySelectorActive: isQuantitySelectorActive, onPropertyFormatChanged: onPropertyFormatChanged, onPropertyFormatCleared: onPropertyFormatCleared, onPropertyFormatSelectorToggled: onPropertyFormatSelectorToggled, onQuantityChange: onQuantityChange, propertyName: propertyName, quantity: quantity, selectedProperties: selectedProperties, translatePropertyValue: translatePropertyValue, validationFilter: validationFilter, valueItems: valueItems }));
    }
    return (React.createElement(UserProfile.UserProfile, null, user => {
        const title = AuthorizationTools.checkPermission(user.applicationClaims, AuthorizationTools.genesysUserClaims.developer)
            ? "GroupName: " + fieldGroup + "\nFieldName: " + fieldName
            : undefined;
        return (React.createElement("td", null, React.createElement("span", { title: title },
            React.createElement(PropertiesSelectorElements.DefaultPropertySelector, Object.assign({}, selectorInfo.selectorComponentProps)))));
    }));
}
function isReadonly(valueSources, selectedProperties, propertyName) {
    if (valueSources.length === 0) {
        return false;
    }
    const sourceInt = property_1.PropertyValueSet.getInteger(`source_${propertyName}`, selectedProperties);
    const valueSource = sourceInt !== undefined
        ? valueSources.find(vs => vs.value === sourceInt)
        : undefined;
    if (valueSource !== undefined) {
        return valueSource.propertyValueSourceId !== "User";
    }
    return valueSources[0].propertyValueSourceId !== "User";
}
//# sourceMappingURL=product-property-selector.js.map